var _style, _circle, _path, _defs, _use, _clipPath, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "home-white_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".home-white_svg__st8{fill:#fff}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 750.4,
    cy: 253.8,
    r: 32.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 3.1c-7.9 0-15.7 2.8-21.9 8.5L67.4 398.4c-6.7 6.2-10.6 14.9-10.6 24v566c0 17.9 14.6 32.5 32.5 32.5h288.5c17.9 0 32.5-14.6 32.5-32.5V637.9h203.2v350.5c0 17.9 14.6 32.5 32.5 32.5h288.5c17.9 0 32.5-14.6 32.5-32.5v-566c0-9.1-3.8-17.8-10.6-24L842.8 294.3l-.8-.7c-3.7-3.2-8.1-5.7-12.9-7-2.8-.8-5.7-1.2-8.7-1.2-18 0-32.6 14.6-32.6 32.6 0 3.9.7 7.7 2 11.2 1.4 3.9 3.5 7.4 6.2 10.4 1.5 1.7 3.2 3.3 5.1 4.7l101 92.4v519.2H678.6V605.4c0-17.9-14.6-32.5-32.5-32.5H377.9c-17.9 0-32.5 14.6-32.5 32.5v350.5H121.8V436.7L512 79.7l143.8 131.6c1.5 1.8 3.3 3.3 5.2 4.7 3.2 2.4 6.8 4.1 10.8 5.2 2.7.7 5.6 1.1 8.5 1.1 18 0 32.6-14.6 32.6-32.6 0-4.1-.8-8-2.1-11.6-1.8-4.7-4.7-8.9-8.3-12.3l-.4-.3L533.9 11.6c-6.2-5.7-14-8.5-21.9-8.5z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "home-white_svg__SVGID_1_",
    d: "M956.6 398.4L842.8 294.3l-.8-.7c-3.7-3.2-8.1-5.7-12.9-7-2.8-.8-5.7-1.2-8.7-1.2-18 0-32.6 14.6-32.6 32.6 0 3.9.7 7.7 2 11.2 1.4 3.9 3.5 7.4 6.2 10.4 1.5 1.7 3.2 3.3 5.1 4.7l101 92.4v519.2H678.6V605.4c0-17.9-14.6-32.5-32.5-32.5H377.9c-17.9 0-32.5 14.6-32.5 32.5v350.5H121.8V436.7L512 79.7l143.8 131.6c1.5 1.8 3.3 3.3 5.2 4.7 3.2 2.4 6.8 4.1 10.8 5.2 2.7.7 5.6 1.1 8.5 1.1 18 0 32.6-14.6 32.6-32.6 0-4.1-.8-8-2.1-11.6-1.8-4.7-4.7-8.9-8.3-12.3l-.4-.3L533.9 11.6C521.5.2 502.4.2 490 11.6L67.4 398.4c-6.7 6.2-10.6 14.9-10.6 24v566c0 17.9 14.6 32.5 32.5 32.5h288.5c17.9 0 32.5-14.6 32.5-32.5V637.9h203.2v350.5c0 17.9 14.6 32.5 32.5 32.5h288.5c17.9 0 32.5-14.6 32.5-32.5v-566c.2-9.1-3.7-17.8-10.4-24z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#home-white_svg__SVGID_1_"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "home-white_svg__SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#home-white_svg__SVGID_1_"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#home-white_svg__SVGID_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.8 385l83.5 65.8 733.5 11.7L980.3 371l-417-391.5h-93z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 929,
    cy: 417.9,
    r: 32.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWhite);
export default ForwardRef;